export const DAY_CANNOT_REPEAT = [29, 30, 31];
